/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './PlaceOrder-ActionTypes';

export const paymentPlaceOrder = (payload) => ({
    type: actionTypes.PAYMENT_PLACE_ORDER,
    payload,
});

export const applePayMerchantProcess = (payload) => ({
    type: actionTypes.APPLE_PAY_MERCHANT_PROCESS,
    payload,
});

export const paymentPlaceOrderCompleted = (payload) => ({
    type: actionTypes.PAYMENT_PLACE_ORDER_COMPLETED,
    payload,
});
